import {Creature, WarriorClass} from "@/store/level/types";
import {EffectType} from "@/store/artifact/types";
import {Amount} from "@/model/amount";
import {Balance, Player} from "@/store/player/types";
import {ResourceType} from "@/store/place/types";
import {ConsumableType} from "@/store/consumable/types";
import {CardType} from "@/store/card/types";

export interface ShopState {
    shopCreatures: ShopCreature[];
    bankOptions: BankOption[];
    bankGifts: BankGift[];
    artifactOptions: ShopArtifact[];
    boosters: BoostersDto | undefined;
    bonusStatus: BonusStatusInfo | undefined;
    rewardedInfo: RewardedInfo | undefined;
}

export class ShopCreature {
    id!: string;
    creature!: Creature;
    creatures!: Creature[];
    titles!: string[];
    descriptions!: string[];
    oldPrice!: number;
    price!: number;
    resourceType?: ResourceType;
    newCreature!: boolean;
    bunchTitle!: string;
    bankOption !: BankOption;
}

export class BankOption {

    price!: number;
    title!: string;
    valuteName!: string;

    // =======================
    // Вот эти три поля можно выкосить с фронта. Но с бэка - нельзя, они должны остаться для обратной совместимости
    gems!: number;
    bonus!: number;
    imageId!: string;
    // =======================

    // Новые поля, которые надо использовать для отображения панели с покупкой:
    id!: string;
    description!: string;
    uniqueness!: Uniqueness;
    validTill!: number;
    decorationId!: string;
    items!: PurchaseItem[];
}

export enum Uniqueness {
    USUAL = 'USUAL',
    UNIQUE = 'UNIQUE',
    RARE = 'RARE'
}


export class RobokassaPurchaseData {
    merchantLogin!: string;
    outSum!: string;
    invId!: number;
    description!: string;
    receipt!: string;
    shp_curr!: string;
    shp_user!: string;
    culture!: string;
    encoding!: string;
    signatureValue!: string;
}

export class ShopArtifact {
    bunchId!: string;
    oldPrice!: Amount;
    price!: Amount;
    bunchName!: string;
    artifacts!: SimpleShopArtifact[];
}
export class SimpleShopArtifact {
    atlasKey!: string;
    imageKey!: string;
    name!: string;
    effectType!: EffectType;
    effectValue!: number;
    effectMaxValue!: number;
    level!: number;
    maxLevel!: number;
    targets!: ShopArtifactTarget[];
    biggestDiscount!: number;
    artifactId!: string;

}

export class ShopForce {
    warriorClass!: WarriorClass;
    name!: string;
    content!: string;
    price!: number;
    creatureId!: number;
    exist!: boolean;
}

export class ShopArtifactTarget {
    creatureId!: number;
    prices!: ShopArtifactTargetPrice[];
}

export class ShopArtifactTargetPrice {
    oldUnlockPrice!: number;
    newUnlockPrice!: number;
    hasFreeSlots!: boolean;
    discount!: number;
}

export class CreaturePrice {
    creatureId!: number;
    price!: number;
}

export class HeroExchangeOptions {

    shopCreatures!: ShopCreature[];
    myCreaturePrices!: CreaturePrice[];
}

export class HeroExchangeDetails {
    price!: number;
    additionalAttack!: number;
}

export class BoostersDto {
    boosters!: BoosterDto[];
    myBoosters!: ActiveBooster[];
    balance!: Balance;
    currentTime!: string;
}

export class BoosterDto {
    boosterType!: BoosterType;
    name!: string;
    desc!: string;
    hours!: number;
    initialPrice!: number;
    finalPrice!: number;
    bonuses!: BonusConfig[];
    sumType!: SumType;
    validTill!: string;
}

export class BonusConfig {
    boosterNarrowCategory!: BoosterNarrowCategory;
    ratio!: number;
}

export class ActiveBooster {
    boosterType!: BoosterType;
    validTill!: string;
}

export enum SumType {
    UNAVAILABLE = 'UNAVAILABLE',
    REPLACE = 'REPLACE',
    BUY = 'BUY',
    APPEND = 'APPEND'
}

export enum BoosterNarrowCategory {
    EXP = 'EXP',
    HEALTH = 'HEALTH',
    RECOVER = 'RECOVER'
}

export enum BoosterType {
    EXP_SMALL = 'EXP_SMALL',
    EXP_MIDDLE = 'EXP_MIDDLE',
    EXP_BIG = 'EXP_BIG',
    HEALTH_SMALL = 'HEALTH_SMALL',
    HEALTH_MIDDLE = 'HEALTH_MIDDLE',
    HEALTH_BIG = 'HEALTH_BIG',
    RECOVER_SMALL = 'RECOVER_SMALL',
    RECOVER_MIDDLE = 'RECOVER_MIDDLE',
    RECOVER_BIG = 'RECOVER_BIG',
    COMPLEX_SMALL = 'COMPLEX_SMALL',
    COMPLEX_MIDDLE = 'COMPLEX_MIDDLE',
    COMPLEX_BIG = 'COMPLEX_BIG'
}

export class PurchaseInfo {
    paidGemsToTake!: number;
    bonusGemsToTake!: number;
    bonusTicketsToTake!: number;
    pointsToTake!: number;
    remainTillNextStatus!: number;
    healthToAll!: number;
    mythDiscount!: number;
    currentStatus!: BonusStatus;
    statusAfterPurchase!: BonusStatus;
    nextTargetStatus!: BonusStatus;
    creatures!: Creature[];
    receiveCreatureAfterEmeralds!: boolean;
    booster!: BoosterDto;
    name!: string;
    items!: PurchaseItem[];
}

export class PurchaseItem {
    creature!: Creature;
    itemType!: ItemType;
    id!: string;
    count!: number;
    giftSenderName?: string;
}


export enum ItemType {
    HERO = 'HERO',
    SILVER_CHEST = 'SILVER_CHEST',
    GOLD_CHEST = 'GOLD_CHEST',
    AZURE_CHEST = 'AZURE_CHEST',
    LAVA_CHEST = 'LAVA_CHEST',
    ELEPHANT = 'ELEPHANT',
    GEMS = 'GEMS',
    GEMS_BONUS = 'GEMS_BONUS',
    ATTACK_COMBATIVE = 'ATTACK_COMBATIVE',
    DEFENCE_COMBATIVE = 'DEFENCE_COMBATIVE',
    HEALTH_COMBATIVE = 'HEALTH_COMBATIVE',
    HEALTH = 'HEALTH',
    MYTH_DISCOUNT = 'MYTH_DISCOUNT',
    TICKETS = 'TICKETS',
    GEMS_BONUS_PROGRAM = 'GEMS_BONUS_PROGRAM',
    AMBER_CHEST = 'AMBER_CHEST',
    JADE_CHEST = 'JADE_CHEST',
    CRYSTAL = 'CRYSTAL',
    ELIXIR = 'ELIXIR',
    GOLD = 'GOLD',
    ATTACK_COMBATIVE_ABS = 'ATTACK_COMBATIVE_ABS',
    DEFENCE_COMBATIVE_ABS = 'DEFENCE_COMBATIVE_ABS',
    HEALTH_COMBATIVE_ABS = 'HEALTH_COMBATIVE_ABS',
    CAVIAR = 'CAVIAR',
    TROPICS_FREE = 'TROPICS_FREE',
    WATER_FREE = 'WATER_FREE',
    ATLANT_FREE = 'ATLANT_FREE',
    EDEM_FREE = 'EDEM_FREE',
    MORFEY_FREE = 'MORFEY_FREE',
    SECRET_FREE = 'SECRET_FREE',
    NY_FREE = 'NY_FREE',
    ARCADIA_FREE = 'ARCADIA_FREE',

    TOKEN = 'TOKEN',
    SNAKE = 'SNAKE',
    EAGLE = 'EAGLE',
    MOUSE = 'MOUSE',
    EVOLUTION_UNIVERSAL = 'EVOLUTION_UNIVERSAL',
    EVOLUTION_ACE = 'EVOLUTION_ACE',
    EVOLUTION_LUCK = 'EVOLUTION_LUCK',
    EVOLUTION_CHAOS = 'EVOLUTION_CHAOS',
    EVOLUTION_DEATH = 'EVOLUTION_DEATH',
    EVOLUTION_DRYAD = 'EVOLUTION_DRYAD',
    EVOLUTION_FACELESS = 'EVOLUTION_FACELESS',
    EVOLUTION_GORGON = 'EVOLUTION_GORGON',
    EVOLUTION_HUMAN = 'EVOLUTION_HUMAN',
    EVOLUTION_INKUB = 'EVOLUTION_INKUB',
    EVOLUTION_KOSCHEY = 'EVOLUTION_KOSCHEY',
    EVOLUTION_MANTICORE = 'EVOLUTION_MANTICORE',
    EVOLUTION_NUN = 'EVOLUTION_NUN',
    EVOLUTION_PHOENIX = 'EVOLUTION_PHOENIX',
    EVOLUTION_RIDER = 'EVOLUTION_RIDER',
    EVOLUTION_SHADOW = 'EVOLUTION_SHADOW',
    EVOLUTION_SPHINX = 'EVOLUTION_SPHINX',
    EVOLUTION_SUKKUB = 'EVOLUTION_SUKKUB',
    EVOLUTION_WITCH = 'EVOLUTION_WITCH',
    EVOLUTION_DRUID = 'EVOLUTION_DRUID',
    EVOLUTION_BERSERK = 'EVOLUTION_BERSERK',
    EVOLUTION_SKULD = 'EVOLUTION_SKULD',
    EVOLUTION_SIKJI = 'EVOLUTION_SIKJI',
    ATTACK_CLAN = 'ATTACK_CLAN',
    DEFENCE_CLAN = 'DEFENCE_CLAN',
    HEALTH_CLAN = 'HEALTH_CLAN',
    ARK_CARD = 'ARK_CARD',
    CONSUMABLE = 'CONSUMABLE',
    ARTIFACT = 'ARTIFACT',
    GOOD_POINTS = 'GOOD_POINTS',
    EVIL_POINTS = 'EVIL_POINTS',
    ORE_GOLD = 'ORE_GOLD',
    SULFUR = 'SULFUR',
    HONEY = 'HONEY',
    SILVER_BOOSTER = 'SILVER_BOOSTER',
    PLATINUM_BOOSTER = 'PLATINUM_BOOSTER',

    CRAFT_LEATHER = 'CRAFT_LEATHER',
    CRAFT_FUR = 'CRAFT_FUR',
    CRAFT_FANGS = 'CRAFT_FANGS',
    CRAFT_ORCHID = 'CRAFT_ORCHID',
    CRAFT_HOGWEED = 'CRAFT_HOGWEED',
    CRAFT_THORN = 'CRAFT_THORN',
    CRAFT_CLOTHES_BAD = 'CRAFT_CLOTHES_BAD',
    CRAFT_CLOTHES_GOOD = 'CRAFT_CLOTHES_GOOD',
    CRAFT_BOUQUET_BAD = 'CRAFT_BOUQUET_BAD',
    CRAFT_BOUQUET_GOOD = 'CRAFT_BOUQUET_GOOD',
    CRAFT_SPEAR = 'CRAFT_SPEAR',
    CRAFT_GLOVES = 'CRAFT_GLOVES',
    CRAFT_NOTEPAD = 'CRAFT_NOTEPAD',
}

export const CRAFT_ITEM_TYPE_TO_RESOURCE_ID: { [key: string]: string } = {
    [ItemType.CRAFT_LEATHER]: 'pi_2o_craft_leather',
    [ItemType.CRAFT_FUR]: 'pi_2o_craft_fur',
    [ItemType.CRAFT_FANGS]: 'pi_2o_craft_fangs',
    [ItemType.CRAFT_ORCHID]: 'pi_2o_craft_orchid',
    [ItemType.CRAFT_HOGWEED]: 'pi_2o_craft_hogweed',
    [ItemType.CRAFT_THORN]: 'pi_2o_craft_thorn',
    [ItemType.CRAFT_CLOTHES_BAD]: 'pi_2o_craft_clothes_bad',
    [ItemType.CRAFT_CLOTHES_GOOD]: 'pi_2o_craft_clothes_good',
    [ItemType.CRAFT_BOUQUET_BAD]: 'pi_2o_craft_bouquet_bad',
    [ItemType.CRAFT_BOUQUET_GOOD]: 'pi_2o_craft_bouquet_good',
    [ItemType.CRAFT_SPEAR]: 'pi_2o_craft_spear',
    [ItemType.CRAFT_GLOVES]: 'pi_2o_craft_gloves',
    [ItemType.CRAFT_NOTEPAD]: 'pi_2o_craft_notepad',
};

export enum ShopArtifactContext {
    COMMON_SHOP = 'COMMON_SHOP',
    ARTIFACT_TOWN = 'ARTIFACT_TOWN'
}

export class BonusStatusInfo {
    points!: number;
    validTill!: string;
    remainTime!: string;
    status!: BonusStatus;
    nextStatus!: BonusStatus;
    currentBonusPercent!: number;
    remainTillNextStatus!: number;
}

export class RewardedInfo {
    todayWatchTimes!: number;
    maxWatchTimes!: number;
    reward!: number;
    enabled!: boolean;
}

export class RewardedResult {
    reward!: number;
    player!: Player;
}

export class BankDto {
    bankOptions!: BankOption[];
    bankGifts!: BankGift[];
    bonusStatusInfo!: BonusStatusInfo;
    rewardedInfo!: RewardedInfo;
}

export class BankGift {
    id!: number;
    name!: string;
    identifier!: string;
    gems!: number;
}


export class PortalShopDto {
    creatures!: ShopCreature[];
    nsCount!: number;
    haveIds!: string[];
}

export enum BonusStatus {
    NONE = 'NONE',
    SILVER = 'SILVER',
    GOLD = 'GOLD',
    BRILLIANT = 'BRILLIANT'
}

export class AvatarDto {
    id!: string;
    price!: number;
}

export enum HeroShopType {
    HERO_TOWN = 'HERO_TOWN',
    TITAN_TOWN = 'TITAN_TOWN',
    ANGEL_TOWN = 'ANGEL_TOWN',
    YOTUN_TOWN = 'YOTUN_TOWN',
    SUR_TOWN = 'SUR_TOWN',
    AMETIST_SHOP = 'AMETIST_SHOP',
    WATER_SHOP = 'WATER_SHOP',
    SHADOW_SHOP = 'SHADOW_SHOP',
    MARKET_SHOP = 'MARKET_SHOP',
    MARKET_SHOP_DISPLACED = 'MARKET_SHOP_DISPLACED',
    PORTAL_SHOP = 'PORTAL_SHOP',
    RANK_SHOP = 'RANK_SHOP',
    ELEPH_SHOP = 'ELEPH_SHOP',
    MOUSE_SHOP = 'MOUSE_SHOP',
    HONEY_CARD_SHOP = 'HONEY_CARD_SHOP',
    HONEY_RANK_SHOP = 'HONEY_RANK_SHOP',
    HONEY_HERO_SHOP = 'HONEY_HERO_SHOP',
    ARTIFACT_TOWN = 'ARTIFACT_TOWN',
    MONASTERY_SHOP = 'MONASTERY_SHOP',
    OBLIVION_SHOP = 'OBLIVION_SHOP',
    FRACTION_GOOD = 'FRACTION_GOOD',
    FRACTION_EVIL = 'FRACTION_EVIL',
    MONASTERY_EX = 'MONASTERY_EX',
    PORTAL_EX = 'PORTAL_EX',
}

export enum RewardedAdvType {
    GEMS = 'GEMS',
    HEALTH_RESTORE = 'HEALTH_RESTORE',
    SPEEDUP_ARENA = 'SPEEDUP_ARENA'
}

export class ShopRankDto {
    id!: number;
    name!: string;
    description!: string;
    creature!: Creature;
    price!: number;
}

export class ShopElephant {
    id!: string;
    count!: number;
    name!: string;
    description!: string;
    price!: number;
}

/**
 * Позиция витрины Медовой башни. В отличие от ShopElephant каждая позиция - своя карта,
 * поэтому приезжает cardType: по нему подбирается картинка карты в витрине.
 */
export class ShopHoneyCard {
    id!: string;
    cardType!: CardType;
    count!: number;
    name!: string;
    description!: string;
    price!: number;
}

export class OblivionTokenDto {
    bankOptions!: BankOption[];
    creatureToTokens!: CreatureToToken[];
    tokens!: number;
}

export class CreatureToToken {
    creatureId!: number;
    title!: string;
    desc!: string;
    price!: number;
}

export class OblivionHeroDto {
    creatures!: ShopCreature[];
    bankOptions!: BankOption[];
    tokens!: number;
}

export class MonasteryDto {

    creatures!: ShopCreature[];
    bankOptions!: BankOption[];
    nsCount!: number;
    maxRank!: number;
    comment1!: string;
    comment2!: string;
}

export class Monastery10Dto {
    creatures!: ShopCreature[];
    myCreaturePrices!: CreaturePrice[];
    bankOptions!: BankOption[];
}

export interface MarketInfo {
    creatures: ShopCreature[];
    consumables: ConsumableMarketDto[];
    markerItems: MarkerItemShopDto[];
    cards: CardMarketDto[];
}

export interface ConsumableMarketDto {
    consumable: ConsumableDto;
    price: number;
    resourceType: ResourceType;
}

export interface ConsumableDto {
    id: string;
    imageId: string;
    consumableType: ConsumableType;
    effectType: EffectType;
    effectValue: number;
    description: string;
    name: string;
    minPlayerStair: number;
    markerId: string;
}

export interface MarkerItemShopDto {
    id: string;
    name: string;
    imageKey: string;
    desc: string;
    price: number;
    resourceType: ResourceType;

    giveMarkerAfterPurchase: string;
}

export interface CardMarketDto {
    id: string;
    name: string;
    imageId: string;
    description: string;
    price: number;
    resourceType: ResourceType;
    cardType: CardType;
    count: number;
}

export class PromocodeResult {
    success!: boolean;
    message!: string;
    items!: PurchaseItem[];
    player!: Player | null;
}
